import React from 'react'
import FeatureImage from "../../assets/images/DeathModuleNew/Feature.png";

export const PersonalItemsDashboard = (props) => {
  return (
    <div>
    <div style={{display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column"}}>
    <img width={158} height={158} src={FeatureImage} alt='FeatureImage'></img>
    
    <div className='personalItemTitle' >{props.role !== "trustee" ? "PERSONAL INFORMATION LOCATION" :"This information will be available to you soon!" }</div>
    </div>
    </div>
  )
}
